import { AttributeDefinition } from '../attributes/attributeDefinition';
import { QuestionDefinitionModel } from '../form/question-definition-model';

export class ApplicationQuestion extends QuestionDefinitionModel {
  public static parse(data: any): ApplicationQuestion {
    if (!data) return null;

    let applicationQuestion = new ApplicationQuestion();
    Object.assign(applicationQuestion, data);

    applicationQuestion.attributeDefinition = AttributeDefinition.parse(
      applicationQuestion.attributeDefinition
    );
    return applicationQuestion;
  }
}
